<template>
  <div id="app" class="wrapper">
    <div class="navbar-minimize-fixed">
      <button class="minimize-sidebar btn btn-link btn-just-icon">
        <i
          class="tim-icons icon-align-center visible-on-sidebar-regular text-muted"
        ></i>
        <i
          class="tim-icons icon-bullet-list-67 visible-on-sidebar-mini text-muted"
        ></i>
      </button>
    </div>
    <app-header v-if="!noHeader" :class="['fixed-header', isStaging ? 'header-staging' : 'header-prod']"></app-header>
    <app-side-bar v-if="!noSideBar"></app-side-bar>
    <div :class="['main-panel', isStaging ? stagingClass : prodClass]">
      <div :class="'content ' + (noSideBar ? 'pl-30' : '')" id="content">
        <router-view  />
        <iphone-frame-preview v-if="hasIphoneContainer"></iphone-frame-preview>
      </div>
    </div>
    <!-- Global Error Handler -->
    <global-error-handler />
  </div>
</template>

<script>
import Header from "@/components/Header";
import SideBar from "@/components/SideBar";
import GlobalErrorHandler from "@/components/common/GlobalErrorHandler";
import 'vue-datetime/dist/vue-datetime.css'

export default {
  data() {
    return {
      stagingClass: 'bgStaging',
      prodClass: 'bgProd'
    }
  },
  components: {
    appHeader: Header,
    appSideBar: SideBar,
    GlobalErrorHandler
  },
  computed: {
    noHeader() {
      return this.$route.name == "Signin";
    },
    hasIphoneContainer(){
      const page = this.$route.name
      return page == 'Graph' || page == 'Dashboard'
    },
    noSideBar(){
      const pages = ["Home", "Signin", "Create", "Edit", "LoginCallback", "OldHome","AuthProcessing"]
      return pages.indexOf(this.$route.name) >= 0 || this.$route.meta?.noSidebar
    },
    isStaging() {
        return (window.location.host.indexOf('staging')>=0 || window.location.host.indexOf('dev')>=0) || window.location.host.indexOf('localhost')>=0
      },
    },
  mounted() {
    this.updatePageTitle();
    if (!this.$root.isAuthenticated && this.$route.meta.requiresAuth) {
      this.$router.push('/signin');
    }
  },
  watch: {
    '$route'() {
      this.updatePageTitle();
    },
    '$store.state.app.activeApp'() {
      this.updatePageTitle();
    },
    '$store.state.app.appsDetails': {
      handler() {
        this.updatePageTitle();
      },
      deep: true
    }
  },
  methods: {
    updatePageTitle() {
      const environment = this.isStaging ? 'Staging' : 'Prod';
      const activeAppId = this.$store.getters['app/activeApp'];
      const appsDetails = this.$store.getters['app/appsDetails'];

      const hasAppIdInRoute = this.$route.params && this.$route.params.aid;

      if (hasAppIdInRoute && activeAppId && appsDetails && appsDetails[activeAppId]) {
        const appName = appsDetails[activeAppId].appname || activeAppId;
        document.title = `Config ${environment}: ${appName}`;
      } else {
        document.title = `Config ${environment}`;
      }
    }
  }
};

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

Array.prototype.last = function() {
  return this[this.length - 1];
};

String.prototype.abbr = function() {
  return this.split(" ")
    .map((item) => item[0])
    .join("")
    .toUpperCase();
};

document.scrollTop = function() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}
</script>

<style>

.bgStaging{
  background: linear-gradient(#0A2F38, #021B29);
  background-attachment: fixed;
}

.bgProd {
  background: linear-gradient(#1e1e2f, #1e1e24);
  background-attachment: fixed;
}
html, body {
  line-height: unset;
}

.table-responsive {
  overflow: unset;
}
.sidebar .sidebar-wrapper {
  overflow: unset;
}

.pl-30 {
  padding-left: 30px !important;
}

.flex1 {
  flex: 1
}

#content {
  display: flex;
}

/* Fixed header styles */
.fixed-header {
  position: fixed !important;
  top: 0 !important;
  left: 0;
  right: 0;
  z-index: 1040;
}

.fixed-header.navbar.header-staging {
  background: linear-gradient(#0A2F38, #021B29) !important;
  background-attachment: fixed !important;
}

.fixed-header.navbar.header-prod {
  background: linear-gradient(#1e1e2f, #1e1e24) !important;
  background-attachment: fixed !important;
}

.bg-black {
  background-color: black;
}

.bold {
  font-weight: bold;
}

.cursor {
  cursor: pointer
}

.errorBox {
  color: red
}

.autocomplete-input {
  border: 1px solid #000;
  border-radius: 8px;
  width: 100%;
  padding: 0.5rem 48px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  line-height: 1.5;
  flex: 1;
  background-color: #eee;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
  background-repeat: no-repeat;
  background-position: 12px;
}
.autocomplete-input:focus,
.autocomplete-input[aria-expanded="true"] {
  border-color: rgba(0, 0, 0, 0.12);
  background-color: #fff;
  outline: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}
[data-position="below"] .autocomplete-input[aria-expanded="true"] {
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
}
[data-position="above"] .autocomplete-input[aria-expanded="true"] {
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  z-index: 2;
}
.autocomplete[data-loading="true"]:after {
  content: "";
  border: 3px solid rgba(0, 0, 0, 0.12);
  border-right-color: rgba(0, 0, 0, 0.48);
  border-radius: 100%;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  animation: rotate 1s linear infinite;
}
.autocomplete-result-list {
  margin: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 0;
  box-sizing: border-box;
  max-height: 296px;
  overflow-y: auto;
  background: #fff;
  list-style: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
}
[data-position="below"] .autocomplete-result-list {
  margin-top: -1px;
  border-top-color: transparent;
  border-radius: 0 0 8px 8px;
  padding-bottom: 8px;
}
[data-position="above"] .autocomplete-result-list {
  margin-bottom: -1px;
  border-bottom-color: transparent;
  border-radius: 8px 8px 0 0;
  padding-top: 8px;
}
.autocomplete-result {
  cursor: default;
  padding: 12px 12px 12px 48px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
  background-repeat: no-repeat;
  background-position: 12px;
}
.autocomplete-result:hover,
.autocomplete-result[aria-selected="true"] {
  background-color: rgba(0, 0, 0, 0.06);
}
@keyframes rotate {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(359deg);
  }
}

.autocomplete-result, .vdatetime-input {
  color: #000 !important;
}

.modal.show .modal-dialog {
  transform: none;
}

.line-hover:hover {
  background-color: #8374cf;
  transition: all 1s;
  cursor: pointer;
  border-radius: 8px;
}

.line-hover{
  align-items: center;
}
.vl {
  border-left: 1px solid #778CA3;
  height: 1rem;
}
.center-para{
  margin-top: auto;
  margin-bottom: auto;
}

.desc-row{
  margin-top: 2em;
  margin-left: 1em;
}
.textarea{
  font: inherit;
  background-color: inherit; 
  color: white; 
  width: 100%;
  border-color: white;
  border-radius: 7px;  
  padding: 7px;
}

.bordered{
  border: 1px dashed #39395c;
  border-radius: 7px;  
  padding: 7px;
}

.action-button{
  padding: 5px 10px;
}

hr.dashed {
  border-top: 3px dashed #39395c;
}

select{
  background-color: #27283b;
  color: white;
  border-radius: 5px;
}

.create-button{
 margin-top: -10px;
 margin-left: -13px;
}

.info{
  border: #949CC9 1px dashed;
  font-style: italic;
  display: none;
  margin-top: 1rem;
}

.info pre{
  margin-top: 1rem;
}


</style>
